/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import { useBrand, useQuery } from '@contexts/index'
import Warning from '@assets/icons/warning.svg'
import Tick from '@assets/icons/tick.svg'

const FindDealer = ({ search, label, infoText, isError, value, optional, hidden }) => {
  const searchInput = useRef(value)
  const brand = useBrand()
  const query = useQuery()
  const [isSearching, setIsSearching] = useState(false)
  const [isDealerFound, setDealerFound] = useState(true)
  const [dealersCount, setDealersCount] = useState(0)

  useEffect(() => {
    searchInput.current.value = value
  }, [value])

  useEffect(() => {
    // if (!maps) return;
    window.customMap = new mapsWrapper.DynamicMap(
      document.createElement('div'),
      {
        accessToken:
          brand === 'lexus'
            ? process.env.NEXT_PUBLIC_LEXUS_MAPBOX_TOKEN
            : process.env.NEXT_PUBLIC_TOYOTA_MAPBOX_TOKEN,
        countryCode: ['GB', 'IM', 'JE', 'GG'],
        language: 'en',
      },
    )

    // add auto complete
    new mapsWrapper.AutoComplete({
      autoCompleteInput: searchInput.current,
      accessToken:
        brand === 'lexus'
          ? process.env.NEXT_PUBLIC_LEXUS_MAPBOX_TOKEN
          : process.env.NEXT_PUBLIC_TOYOTA_MAPBOX_TOKEN,
      countryCode: ['GB', 'IM', 'JE', 'GG'],
      types: 'place,locality,neighborhood,region,postcode',
      onLocationSelect: (location) => {
        if (location) {
          const lon = location.coordinates[0]
          const lat = location.coordinates[1]
          getDealersList({ lat, lon }, (result) => {
            setDealersCount(result.dealers.length)
            setIsSearching(false)
            search(result.dealers, searchInput.current.value)
            setDealerFound(result.dealers.length > 0)
          })
        }
      },
    })
  }, [])

  const searchByPostcode = (term) => {
    window.customMap.geocoder
      .search(term, { countryCode: ['GB', 'IM', 'JE', 'GG'] })
      .then((geo) => {
        if (geo.length) {
          const lon = geo[0].coordinates[0]
          const lat = geo[0].coordinates[1]
          getDealersList({ lat, lon }, (result) => {
            setDealersCount(result.dealers.length)
            setIsSearching(false)
            search(result.dealers, term)
            setDealerFound(result.dealers.length > 0)
          })
        } else setDealerFound(false)
      })
  }

  const getDealersList = async (coords, callback) => {
    setIsSearching(true)
    const url = query?.group 
      ? `https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/${brand}/gb/en/drive/${coords.lon}/${coords.lat}?count=5000&extraCountries=&isCurrentLocation=false&services=ShowRoom` 
      : `https://kong-proxy-intranet.toyota-europe.com/dxp/dealers/api/${brand}/gb/en/drive/${coords.lon}/${coords.lat}?count=10&extraCountries=&isCurrentLocation=false&services=ShowRoom`

    try {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      const data = await response.json()
      
      if (query?.group) {
        data.dealers = data.dealers
          .filter((i) => i.parent === query.group)
        data.total = data.dealers.length
      }

      data.dealers = data.dealers.filter((i) => i.services.some((j) => j.service === 'ShowRoom'))

      callback(data)
    } catch (error) {
      console.error('Error:', error)
    } finally {
      setIsSearching(false)
    }
  }

  if (hidden) {
    return null
  }

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2"
      data-gt-name="componentevent"
    >
      <div className="md:col-span-2 lg:col-span-1">
        <label>{label}</label>              {optional && (
          <span className="text-xs lowercase whitespace-nowrap">
            (optional)  
          </span>
        )}
        <br />
        <p className="text-xs whitespace-nowrap">{infoText}</p>
        <div className="relative">
          <input
            type="text"
            id={`places`}
            ref={searchInput}
            className={` ${isError && 'border-red'} ${
              dealersCount > 0 && 'border-green'
            } relative p-4 h-[48px] mb-[6px] pl-[40px] mt-2 pr-[52px] w-[100%] text-ellipsis overflow-hidden`}
            data-gt-action="text-input-interaction"
            data-gt-label={`places`}
          />
          <div className="pointer-events-none absolute inset-y-0 bottom-0 left-[2px] flex items-center pl-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5  "
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
              />
            </svg>
          </div>
          <div
            className={` z-9 absolute inset-y-0 bottom-[-9px] right-[60px] flex items-center pl-3`}
          ></div>
          <div
            className={` z-9 absolute inset-y-0  top-2 right-[40px] flex items-center pl-3`}
          >
            {isError && (
              <Warning className="absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-red" />
            )}
            {dealersCount > 0 && (
              <Tick className="absolute inset-y-0 right-4 top-4 h-4 pointer-events-none text-green" />
            )}
          </div>

          <button
            disabled={isSearching}
            onClick={(e) => {
              e.preventDefault()
              searchInput.current.value !== '' &&
                searchByPostcode(searchInput.current.value)
              searchInput.current.value === '' && searchInput.current.focus()
            }}
            className={`absolute right-1 bottom-1  ${
              brand === 'lexus'
                ? ' h-12 text-[11px] !uppercase mb-[3px]'
                : ' h-10'
            } px-4 py-1 mb-[6px] p-4  text-sm text-gray capitalize flex items-center justify-center `}
            data-gt-action="find-dealer-cta-click"
            data-gt-label="find"
          >
            {isSearching && <div className="loader dark">Loading...</div>}
            Find
          </button>
        </div>
        {!isDealerFound && (
          <div className="text-red text-tiny flex justify-between pt-1">
            {' '}
            <span>No location found.</span>
          </div>
        )}
        {isError && (
          <div className="text-red text-tiny flex justify-between ">
            {' '}
            <span>
              Please search for your nearest{' '}
              {brand === 'lexus' ? `Lexus centre` : `Toyota dealer`}.
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default FindDealer
